module.exports = __webpack_public_path__ + "img/png.48644e79.png";